<template>
    <div class="card modern-page-card">
        <div class="card-header border-bottom d-flex flex-wrap align-items-center justify-content-between gap-2">
            <div>
                <h5 class="mb-1">العبوات</h5>
                <p class="text-muted small mb-0">وحدات القياس والكميات المرتبطة بالمنتج.</p>
            </div>
            <button type="button" class="btn btn-primary" @click.prevent="openModal()">
                <i class="ti ti-plus me-1"></i> إضافة عبوة
            </button>
        </div>

        <div class="table-responsive">
            <table class="table table-hover table-bordered modern-grid-table mb-0">
                <thead>
                    <tr>
                        <th style="width:3rem;">#</th>
                        <th>وحدة القياس</th>
                        <th>الكمية</th>
                        <th>الترتيب</th>
                        <th class="cell-fit">الإجراءات</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="!items.length">
                        <td colspan="5" class="text-center modern-grid-table__empty">لا توجد بيانات حالية</td>
                    </tr>
                    <tr v-for="(item, index) in items" :key="item.id">
                        <td class="fw-medium">{{ index + 1 }}</td>
                        <td>{{ item.unitMeasureName || '---' }}</td>
                        <td>{{ item.quantity }}</td>
                        <td>{{ item.arrangement }}</td>
                        <td class="cell-fit text-nowrap packagings-actions">
                            <div class="modern-grid-table__actions flex-nowrap">
                                <a href="javascript:;"
                                   @click.prevent="openModal(item)"
                                   class="btn btn-icon btn-text-secondary waves-effect waves-light rounded-pill"
                                   title="تعديل"
                                   aria-label="تعديل">
                                    <i class="ti ti-edit ti-md"></i>
                                </a>
                                <a href="javascript:;"
                                   @click.prevent="deletePackaging(item.id)"
                                   class="btn btn-icon btn-text-danger waves-effect waves-light rounded-pill"
                                   title="حذف"
                                   aria-label="حذف">
                                    <i class="ti ti-trash ti-md"></i>
                                </a>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div ref="packagingModalEl" class="modal fade" id="packagingModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-simple modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-body">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        <div class="text-center mb-4">
                            <h4 class="mb-2">{{ form.Id ? 'تعديل عبوة' : 'إضافة عبوة' }}</h4>
                            <p class="text-muted mb-0">حدد وحدة القياس والكمية والترتيب للمنتج.</p>
                        </div>

                        <el-form label-position="top" :model="form" :rules="rules" ref="packagingForm">
                            <div class="row g-3">
                                <div class="col-12">
                                    <el-form-item prop="UnitMeasureId" label="وحدة القياس">
                                        <el-select v-model="form.UnitMeasureId"
                                                   filterable
                                                   clearable
                                                   style="width:100%"
                                                   placeholder="اختر وحدة القياس">
                                            <el-option v-for="unit in unitMeasures" :key="unit.id" :label="unit.name" :value="unit.id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="col-md-6">
                                    <el-form-item prop="Quantity" label="الكمية">
                                        <input type="number" min="0" step="0.01" class="form-control" v-model.number="form.Quantity">
                                    </el-form-item>
                                </div>
                                <div class="col-md-6">
                                    <el-form-item prop="Arrangement" label="الترتيب">
                                        <input type="number" min="1" class="form-control" v-model.number="form.Arrangement">
                                    </el-form-item>
                                </div>
                                <div class="col-12 text-center mt-2">
                                    <button type="button" class="btn btn-primary me-2" @click.prevent="savePackaging()">حفظ</button>
                                    <button type="button" class="btn btn-label-secondary" data-bs-dismiss="modal">إلغاء</button>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2';

export default {
    name: 'PackagingsTab',
    props: {
        productId: { type: Number, required: true },
        initialPackagings: { type: Array, default: () => [] }
    },
    data() {
        return {
            items: [],
            unitMeasures: [],
            form: this.emptyForm(),
            rules: {
                UnitMeasureId: this.$helper.Required(),
                Quantity: this.$helper.Required(),
                Arrangement: this.$helper.Required()
            }
        };
    },
    watch: {
        initialPackagings: {
            immediate: true,
            handler(value) {
                this.items = value || [];
            }
        }
    },
    created() {
        this.loadUnitMeasures();
    },
    mounted() {
        this.movePackagingModalToBody();
    },
    beforeDestroy() {
        const el = this.$refs.packagingModalEl;
        if (!el) return;
        const inst = window.bootstrap && window.bootstrap.Modal.getInstance(el);
        if (inst) inst.hide();
        if (el.parentNode === document.body) {
            document.body.removeChild(el);
        }
    },
    methods: {
        movePackagingModalToBody() {
            const el = this.$refs.packagingModalEl;
            if (!el || el.parentElement === document.body) return;
            document.body.appendChild(el);
        },
        getPackagingModalInstance() {
            const el = this.$refs.packagingModalEl;
            if (!el || !window.bootstrap) return null;
            return window.bootstrap.Modal.getOrCreateInstance(el);
        },
        emptyForm() {
            return { Id: 0, UnitMeasureId: '', Quantity: 1, Arrangement: 1 };
        },
        async loadUnitMeasures() {
            try {
                const response = await this.$http.GetAllDictionaryUnitMeasures();
                this.unitMeasures = response.data.info || [];
            } catch {
                this.unitMeasures = [];
            }
        },
        async loadPackagings() {
            const response = await this.$http.GetProductPackagings(this.productId);
            this.items = response.data.info || [];
        },
        openModal(item) {
            this.form = item
                ? { Id: item.id, UnitMeasureId: item.unitMeasureId, Quantity: item.quantity, Arrangement: item.arrangement }
                : this.emptyForm();
            this.$nextTick(() => {
                this.movePackagingModalToBody();
                if (this.$refs.packagingForm) this.$refs.packagingForm.clearValidate();
                const inst = this.getPackagingModalInstance();
                if (inst) inst.show();
            });
        },
        closeModal() {
            const inst = this.getPackagingModalInstance();
            if (inst) inst.hide();
        },
        savePackaging() {
            this.$refs.packagingForm.validate(async valid => {
                if (!valid) {
                    this.$helper.showSwal('warning');
                    return;
                }
                const payload = {
                    Id: Number(this.form.Id || 0),
                    UnitMeasureId: Number(this.form.UnitMeasureId),
                    Quantity: Number(this.form.Quantity),
                    Arrangement: Number(this.form.Arrangement)
                };
                this.$blockUI.Start();
                try {
                    if (payload.Id) await this.$http.EditProductPackaging(payload.Id, payload);
                    else await this.$http.AddProductPackaging(this.productId, payload);
                    await this.loadPackagings();
                    this.closeModal();
                    this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم حفظ العبوة');
                } catch (err) {
                    const message = err && err.response && err.response.data ? err.response.data : 'تعذر حفظ العبوة';
                    this.$helper.ShowMessage('error', 'خطأ', message);
                } finally {
                    this.$blockUI.Stop();
                }
            });
        },
        deletePackaging(id) {
            Swal.fire({
                title: 'تأكيد الحذف',
                text: 'هل أنت متأكد من حذف هذه العبوة؟',
                icon: 'warning',
                customClass: { confirmButton: 'btn btn-danger', cancelButton: 'btn btn-label-secondary ms-2' },
                buttonsStyling: false,
                showCancelButton: true,
                confirmButtonText: 'حذف',
                cancelButtonText: 'إلغاء'
            }).then(async result => {
                if (!result.isConfirmed) return;
                this.$blockUI.Start();
                try {
                    await this.$http.DeleteProductPackaging(id);
                    await this.loadPackagings();
                    this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم حذف العبوة');
                } catch (err) {
                    const message = err && err.response && err.response.data ? err.response.data : 'تعذر حذف العبوة';
                    this.$helper.ShowMessage('error', 'خطأ', message);
                } finally {
                    this.$blockUI.Stop();
                }
            });
        }
    }
};
</script>

<style scoped>
.packagings-actions a {
    cursor: pointer;
}

.packagings-actions .btn-icon {
    padding: 0.25rem 0.35rem;
}
</style>

<style>
/* المودال داخل التبويبات كان يظهر خلف backdrop — يُنقل إلى body برمجياً مع z-index أعلى */
#packagingModal.modal {
    z-index: 1095 !important;
}

#packagingModal.modal.show .modal-dialog {
    z-index: 1;
    position: relative;
}
</style>
